// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1qzRO","label":"SetPasswdForm_label__2xLge"};